export interface Guild {
  id: number
  role: string
  salary: number
  type: string
}

export interface CreateGuildDto {
  role: string
  salary: number
  type: string
}

export interface GetGuildByIdDto {
  id: number
}

export interface UpdateGuildDto {
  id: number
  role: string
  salary: number
  type: string
}

export const AllGuildTypes = {
  ADM: "Agile_Delivery_Manager",
  BA: "Business_Analyst",
  Design: "Designer",
  Developer: "Developer",
  DevOps: "Developer_Operations",
  GuildMaster: "Guild_Master",
  QA: "Quality_Assurance",
  SM: "Scrum_Master"
} as const

export const GUILD_MASTER_GUILD_TYPE = 'Guild_Master'

/**
 * Guild Masters are assessed with the Guild Master Growth Wheel, regardless of
 * the guild they belong to. Falls back to their own guild when the Guild Master
 * guild is not configured.
 */
export const getGrowthWheelGuildId = (
  member: { guildId: number; isGuildMaster?: boolean },
  guilds: Guild[] | undefined,
) => {
  if (!member.isGuildMaster) return member.guildId
  const guildMasterGuild = guilds?.find(
    guild => guild.type === GUILD_MASTER_GUILD_TYPE,
  )
  return guildMasterGuild?.id ?? member.guildId
}

export const AllGuildTribeHeader = {
  ADM: "Agile Delivery Manager",
  BA: "Business Analyst",
  Design: "Design",
  Developer: "Development",
  DevOps: "OPs",
  GuildMaster: "Guild Master",
  QA: "QA",
  SM: "Scrum Master"
} as const

export const TeamRoles = {
  [AllGuildTypes.QA]: ['QA Lead'],
  [AllGuildTypes.Design]: ['Design Lead'],
  [AllGuildTypes.Developer]: ['Dev Lead'],
  [AllGuildTypes.DevOps]: ['Ops Backup'],
}

export const LeadershipRoleTypes = [
  AllGuildTypes.SM,
  AllGuildTypes.BA,
  AllGuildTypes.ADM
]
